import { IMasterclassDescription } from '@/interfaces/masterclassDescription';
import useMasterclassDescriptionStore from '@/store/MasterClassDescription/useMasterclasDescriptionStore';
import { MASTERCLASS_TYPES } from '@/utils/masterclass/masterclass';
import { Typography } from '@pwskills/rachnaui';
import { Home } from '@pwskills/rachnaui/Icons';
import { useRouter } from 'next/router';

const HeroSection = () => {
  const router = useRouter();
  const { type } = router.query;

  const masterclassDetails = useMasterclassDescriptionStore(
    (state: { masterclassDetails: IMasterclassDescription }) => state.masterclassDetails
  );

  const { title, heroSectionMeta } = masterclassDetails;

  const getBreadcrumbs = () => {
    return (
      <div className="flex items-center gap-1">
        <div className="flex gap-1 justify-center items-center text-gray-650">
          <Home className="w-3 h-3 text-white" />
          <Typography
            component="body-small"
            variant="medium"
            className="text-white cursor-pointer  whitespace-nowrap"
            onClick={() => {
              router.push('/');
            }}
          >
            Home {`>`}
          </Typography>
        </div>
        <Typography
          component="body-small"
          variant="medium"
          className="text-white cursor-pointer whitespace-nowrap"
          onClick={() => {
            router.push('/masterclass');
          }}
        >
          Masterclass {`>`}
        </Typography>
        <Typography
          component="body-small"
          variant="bold"
          className="text-white whitespace-nowrap overflow-hidden text-ellipsis"
        >
          {title}
        </Typography>
      </div>
    );
  };

  return (
    <div className="relative w-full h-fit">
      <div className="relative w-full h-full">
        <img
          className="medium:block small:hidden w-full"
          src={heroSectionMeta?.bgImage}
          alt="web-image"
        />
        <img className="medium:hidden w-full" src={heroSectionMeta?.image} alt="mweb-image" />
        <div className="flex flex-col z-[3] absolute top-4 medium:top-10 left-0 medium:left-10 small:px-4 medium:px-8 large:px-20 w-full">
          {type !== MASTERCLASS_TYPES.MARKETING && getBreadcrumbs()}
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
